/**
 * Scene component extracted from RepairScene
 *
 * Repair meta main scene (SCENE_MAIN) that hosts the interactive repair island as
 * its "home" view. Mirrors features/src/location_simple/simplemainscenecomponent.js
 * for the component/PlayButton wiring, and merge2/src/scene/merge2scenecomponent.js
 * for hosting the island via location.getViewClass(). The gameplay stays in the
 * type's own game scene (SCENE_GAME), launched by the standard PlayButton flow.
 */

class RepairSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setBundles(this.listBundles());
    }

    onSceneLoaded() {
        const location = cleverapps.meta.getSelectedLocation();

        const ViewClass = location.getViewClass();
        this.roomView = new ViewClass(location);
        this.node.addChild(this.roomView);

        location.on("taskWindowShown", this.onTaskWindowShown.bind(this), this.node);
        location.on("taskWindowHidden", this.onTaskWindowHidden.bind(this), this.node);

        this.onResize();
    }

    buildPlayButton() {
        this.playButton = new PlayButtonView();
        return this.playButton;
    }

    hasScoreModeButton() {
        return !!cleverapps.highscore;
    }

    buildScoreModeButton() {
        this.scoreModeButton = new ScoreModeButton();
        return this.scoreModeButton;
    }

    onReady() {
        this.playButton.addFinger();
    }

    getBackgroundStyles() {
        return undefined;
    }

    listBundles() {
        const location = cleverapps.meta.getSelectedLocation();
        return location.listBundles().concat(["repair_view", "new_task_window"]);
    }

    onTaskWindowShown() {
        if (this.roomView.repairViewHiding) {
            this.roomView.repairViewHiding.hide();
        }
    }

    onTaskWindowHidden() {
        if (this.roomView.repairViewHiding) {
            this.roomView.repairViewHiding.show();
        }
    }

    onResize() {
        const bgSize = cleverapps.resolution.getBgSize();
        this.roomView.setContentSize(bgSize);
        this.roomView.setAlignment(this.node.convertToNodeSpace(cc.p(bgSize.width / 2, bgSize.height / 2)));
    }
}

Prefab.registerComponent("RepairSceneComponent", RepairSceneComponent);
